var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { PeekInputSelect } from "@piiqtechnologies/ui-components";
import { getModelsByManufacturer } from "@utils/accessDeviceHelper";
const DeviceModelSelector = (_a) => {
    var { field, form } = _a, props = __rest(_a, ["field", "form"]);
    const models = useMemo(() => {
        if (!form.values.manufacturer || form.values.accessType === "Perimeter Access")
            return [];
        return getModelsByManufacturer(form.values.manufacturer);
    }, [form.values.manufacturer]);
    return (React.createElement(PeekInputSelect, Object.assign({ labelProps: { sx: { fontWeight: "normal" } } }, props, { form: form, field: field, items: models })));
};
export default DeviceModelSelector;
